/*
 * Barre d'achat fixe des fiches produits (snippets/tp-sticky-buy-bar.liquid).
 * - Apparaît quand le bouton principal n'est plus visible à l'écran.
 * - Son menu de variantes pilote le sélecteur principal : un seul champ « id » part au panier,
 *   celui du formulaire principal (l'ancien doublon pouvait ajouter la mauvaise variante).
 * - Suit les changements de variante faits plus haut sur la page : menu, prix, bouton.
 */
(function () {
  class StickyBuyBar {
    constructor(bar) {
      this.bar = bar;
      this.sectionId = bar.dataset.sectionId;
      this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.form = document.getElementById(`product-form-${this.sectionId}`);
      this.select = document.getElementById(`StickyVariantSelect-${this.sectionId}`);
      this.button = bar.querySelector('.sticky-add-to-cart__button');

      this.observeMainButton();
      this.select?.addEventListener('change', () => this.onSelectChange());

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
      }
    }

    observeMainButton() {
      if (!this.mainButton) return;
      new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting)).observe(this.mainButton);
    }

    toggle(visible) {
      clearTimeout(this.hideTimer);
      if (visible) {
        this.bar.hidden = false;
        requestAnimationFrame(() => this.bar.classList.add('is-visible'));
      } else {
        this.bar.classList.remove('is-visible');
        this.hideTimer = setTimeout(() => {
          this.bar.hidden = true;
        }, 300);
      }
    }

    onSelectChange() {
      const option = this.select.selectedOptions[0];
      if (!option) return;

      // Le formulaire principal envoie tout de suite la variante choisie ici.
      const idInput = this.form?.querySelector('input[name="id"]');
      if (idInput) idInput.value = option.value;

      // Le sélecteur principal se met à jour, et Dawn rafraîchit prix, photo et adresse.
      this.selectMainOptions(JSON.parse(option.dataset.options || '[]'));
    }

    selectMainOptions(values) {
      const picker = document.querySelector(`variant-selects[data-section="${this.sectionId}"]`);
      if (!picker) return;

      let changed = null;
      picker.querySelectorAll('.product-form__input').forEach((group, index) => {
        const value = values[index];
        if (value === undefined) return;

        const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
        if (radio) {
          if (!radio.checked) {
            radio.checked = true;
            changed = radio;
          }
          return;
        }

        const select = group.querySelector('select');
        if (select && select.value !== value) {
          select.value = value;
          changed = select;
        }
      });

      changed?.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onVariantChange(event) {
      const { sectionId, html, variant } = event.data || {};
      if (sectionId !== this.sectionId || !html) return;

      if (this.select && variant) this.select.value = String(variant.id);

      const price = document.getElementById(`StickyPrice-${this.sectionId}`);
      const freshPrice = html.getElementById(`StickyPrice-${this.sectionId}`);
      if (price && freshPrice) price.innerHTML = freshPrice.innerHTML;

      const freshButton = html.querySelector(`#StickyAddToCart-${this.sectionId} .sticky-add-to-cart__button`);
      if (this.button && freshButton) {
        this.button.disabled = freshButton.disabled;
        this.button.innerHTML = freshButton.innerHTML;
      }
    }
  }

  function init() {
    document.querySelectorAll('.sticky-add-to-cart').forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      new StickyBuyBar(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
